import { AppState } from '../../../../redux/reducers';
import * as PractitionerConsumptionStore from '../../../../redux/middleware/PractitionerConsumptionMiddleware';
import { Practitioner } from '../../../../models/Entities/Practitioners/Practitioner';
import { PractitionerConsumption } from '../../../../models/Entities/Practitioners/PractitionerConsumption';

interface IProps {
  PractitionerId: string | undefined;
  ConsumptionId: string | undefined;
  isOpen: boolean;
  onClose: () => void;
}

interface ConnectedProps {
  Practitioner: Practitioner | undefined;
  Consumption: PractitionerConsumption | undefined;
  isLoading: boolean;
  isSaving: boolean; // cambio de monto u otra acción en curso
  error: string | undefined;
}

interface DispatchProps {
  ChangeAmount: typeof PractitionerConsumptionStore.ActionCreators.ChangeAmount;
  // ChangeType: futura implementación
}

export type Props = IProps & ConnectedProps & DispatchProps;

export const mapStateToProps = (state: AppState, own: IProps): ConnectedProps => {
  const practitioner = state.Practitioners?.list?.find((p: Practitioner) => p.userId === own.PractitionerId);
  const consumption = practitioner?.consumptions?.find((c: PractitionerConsumption) => c.id === own.ConsumptionId);

  return {
    Practitioner: practitioner,
    Consumption: consumption,
    isLoading: false, // placeholder hasta que exista flag específico
  isSaving: !!consumption?.isAmountChanging,
    error: undefined
  };
};

export const mapDispatchToProps = {
  ...PractitionerConsumptionStore.ActionCreators
};

// simple status description mimic (puede refactorizarse luego a util común)
export const GetStatusDescription = (status: number) => {
  switch (status) {
    case 0: return { text: 'Pendiente de liquidación', class: 'pending' };
    case 1: return { text: 'Con saldo pendiente', class: 'partial' };
    case 2: return { text: 'Pagado', class: 'paid' };
    case 3: return { text: 'Liquidado', class: 'settled' };
    case 4: return { text: 'Rechazado', class: 'rejected' };
    case 5: return { text: 'Ignorado', class: 'ignored' };
    case 6: return { text: 'Para liquidar', class: 'tosettle' };
    case 7: return { text: 'Facturado', class: 'invoiced' };
    default: return { text: 'Desconocido', class: 'unknown' };
  }
};
